
import { defineComponent, ref, watch } from 'vue';
import { useStore } from 'vuex';
export default defineComponent({
  name: 'AdminNav',
  setup() {
    // 导航栏内容
    const tags = [
      {
        icon: 'el-icon-menu',
        index: 'dashboard',
        title: '管理主页',
      },
      {
        icon: 'el-icon-user-solid',
        index: 'user',
        title: '用户管理',
      },
      {
        icon: 'el-icon-s-order',
        index: 'order',
        title: '订单管理',
      },
      {
        icon: 'el-icon-position',
        index: 'flight',
        title: '航班管理',
      },
    ];
    // 响应式切换导航栏
    const store = useStore();
    const selectItem = (index: string) => {
      store.commit('changeActiveAdminNav', index);
    };
    const activeItem = ref('');
    activeItem.value = store.state.activeAdminNavItem;
    watch(
      () => store.state.activeAdminNavItem,
      () => (activeItem.value = store.state.activeAdminNavItem)
    );
    return {
      tags,
      selectItem,
      activeItem,
    };
  },
});
